import { render, staticRenderFns } from "./TipsApp.vue?vue&type=template&id=c627240a&scoped=true&"
import script from "./TipsApp.vue?vue&type=script&lang=js&"
export * from "./TipsApp.vue?vue&type=script&lang=js&"
import style0 from "./TipsApp.vue?vue&type=style&index=0&id=c627240a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c627240a",
  null
  
)

export default component.exports